<ng-container *ngIf="draft">
  <div class="modal" (click)="onCancel()">
    <tm1-card class="modal-content widget-config-content" [class.dark]="dark"
      (click)="$event.stopPropagation()">
      <span class="close" (click)="onCancel()">&times;</span>
      <h2 class="widget-config-title">Configure widget</h2>

      <ng-container *ngIf="draft.type !== 'textNote' && showTitleControls">
        <label class="wc-field">
          <span class="wc-label">Title <em>(optional)</em></span>
          <input type="text" class="form-control" [(ngModel)]="draft.title"
            placeholder="Custom heading" autocomplete="off" maxlength="60" />
        </label>
        <div class="wc-text-style-row">
          <label class="wc-field wc-text-style-item">
            <span class="wc-label">Title size</span>
            <select class="form-control wc-fontsize" [(ngModel)]="draft.titleFontSize">
              <option [ngValue]="undefined">Auto</option>
              <option *ngFor="let size of fontSizes" [ngValue]="size">{{ size }}</option>
            </select>
          </label>
          <div class="wc-field wc-text-style-item">
            <span class="wc-label">Title colour</span>
            <div class="wc-color-row">
              <input type="color" class="wc-color-swatch"
                [value]="draft.titleColor || (dark ? '#f8fafc' : '#0f172a')"
                (input)="onTitleColorChange($event)"
                aria-label="Title colour" />
              <button type="button" class="wc-link" *ngIf="draft.titleColor"
                (click)="draft.titleColor = undefined">Reset</button>
            </div>
          </div>
        </div>
        <label class="wc-toggle-row">
          <input type="checkbox" [checked]="draft.titleBold"
            (change)="draft.titleBold = !draft.titleBold" />
          <span>Bold title</span>
        </label>
      </ng-container>

      <!-- ===================== Stat tile ===================== -->
      <ng-container *ngIf="draft.type === 'statTile'">
        <div class="wc-list-head">
          <span class="wc-label">Metric{{ isSingleSelect ? '' : 's' }}
            <em>{{ isSingleSelect ? '(one per tile)' : '(one tile each)' }}</em></span>
          <button type="button" class="wc-link" *ngIf="!isSingleSelect" (click)="toggleSelectAll()">
            {{ allSelected ? 'Unselect all' : 'Select all' }}
          </button>
        </div>
        <div class="wc-check-list">
          <label class="wc-check" *ngFor="let opt of statOptions"
            [class.wc-check-disabled]="isDisabled(opt.value)">
            <input type="checkbox" [checked]="isSelected(opt.value)"
              [disabled]="isDisabled(opt.value)" (change)="toggle(opt.value)" />
            <span>{{ opt.label }}</span>
          </label>
        </div>
        <label class="wc-toggle-row">
          <input type="checkbox" [checked]="!draft.hideBackground"
            (change)="draft.hideBackground = !draft.hideBackground" />
          <span>Show widget background</span>
        </label>
      </ng-container>

      <!-- ===================== Scan rate by entrance ===================== -->
      <ng-container *ngIf="draft.type === 'scanRateByEntrance'">
        <label class="wc-toggle-row">
          <input type="checkbox" [checked]="draft.useGrouping" (change)="onGroupingToggle()" />
          <span>Group entrances</span>
          <button type="button" class="wc-link" (click)="openEntranceGroups()">Manage groups</button>
        </label>
        <div class="wc-list-head">
          <span class="wc-label">Entrances</span>
          <button type="button" class="wc-link" (click)="toggleSelectAll()">
            {{ allSelected ? 'Unselect all' : 'Select all' }}
          </button>
        </div>
        <div class="wc-check-list">
          <label class="wc-check" *ngFor="let name of availableEntrances">
            <input type="checkbox" [checked]="isSelected(name)" (change)="toggle(name)" />
            <span>{{ name }}</span>
          </label>
        </div>
      </ng-container>

      <!-- ===================== Errors by result code ===================== -->
      <ng-container *ngIf="draft.type === 'errorsByResultCode'">
        <div class="wc-list-head">
          <span class="wc-label">Result codes</span>
          <button type="button" class="wc-link" (click)="toggleSelectAll()">
            {{ allSelected ? 'Unselect all' : 'Select all' }}
          </button>
        </div>
        <div class="wc-check-list">
          <label class="wc-check" *ngFor="let code of availableCodes">
            <input type="checkbox" [checked]="isSelected(code)" (change)="toggle(code)" />
            <span>{{ formatErrorCode(code) }}</span>
          </label>
        </div>
      </ng-container>

      <!-- ===================== Graphs ===================== -->
      <ng-container *ngIf="draft.type === 'multiLineGraph' || draft.type === 'entranceGraph'">
        <span class="wc-label">Source</span>
        <div class="wc-radio-list wc-inline">
          <label class="wc-radio">
            <input type="radio" name="graphSource" [checked]="draft.graphSource !== 'scanner'"
              (change)="onGraphSourceChange('gate')" />
            <span>Gates</span>
          </label>
          <label class="wc-radio">
            <input type="radio" name="graphSource" [checked]="draft.graphSource === 'scanner'"
              (change)="onGraphSourceChange('scanner')" />
            <span>Scanners</span>
          </label>
        </div>
        <div class="wc-list-head">
          <span class="wc-label">
            {{ draft.type === 'entranceGraph'
              ? (isSingleSelect ? 'Entrance' : 'Entrances (one graph each)')
              : 'Entrances' }}
          </span>
          <button type="button" class="wc-link" *ngIf="!isSingleSelect" (click)="toggleSelectAll()">
            {{ allSelected ? 'Unselect all' : 'Select all' }}
          </button>
        </div>
        <div class="wc-check-list">
          <label class="wc-check" *ngFor="let name of availableEntrances"
            [class.wc-check-disabled]="isDisabled(name)">
            <input type="checkbox" [checked]="isSelected(name)"
              [disabled]="isDisabled(name)" (change)="toggle(name)" />
            <span>{{ name }}</span>
          </label>
        </div>
      </ng-container>

      <!-- ===================== Standalone image ===================== -->
      <ng-container *ngIf="draft.type === 'image'">
        <span class="wc-label">Image</span>
        <div class="wc-image-row">
          <label class="wc-btn wc-upload-btn">
            {{ draft.imageData ? 'Replace image' : 'Upload image' }}
            <input type="file" accept="image/*" (change)="onImageSelected($event)" hidden />
          </label>
          <button type="button" class="wc-link" *ngIf="draft.imageData" (click)="removeImage()">
            Remove
          </button>
          <span class="wc-image-status" *ngIf="imageBusy">Processing…</span>
        </div>
        <img class="wc-image-preview" *ngIf="draft.imageData" [src]="draft.imageData"
          alt="Image preview" />
        <p class="wc-error" *ngIf="imageError">{{ imageError }}</p>
      </ng-container>

      <!-- ===================== Venue map ===================== -->
      <ng-container *ngIf="draft.type === 'venueMap'">
        <span class="wc-label">Floor-plan image</span>
        <div class="wc-image-row">
          <label class="wc-btn wc-upload-btn">
            {{ draft.imageData ? 'Replace image' : 'Upload image' }}
            <input type="file" accept="image/*" (change)="onImageSelected($event)" hidden />
          </label>
          <button type="button" class="wc-link" *ngIf="draft.imageData" (click)="removeImage()">
            Remove
          </button>
          <span class="wc-image-status" *ngIf="imageBusy">Processing…</span>
        </div>
        <img class="wc-image-preview" *ngIf="draft.imageData" [src]="draft.imageData"
          alt="Floor-plan preview" />
        <p class="wc-error" *ngIf="imageError">{{ imageError }}</p>

        <div class="wc-list-head">
          <span class="wc-label">Entrance markers</span>
          <button type="button" class="wc-link" (click)="toggleSelectAll()">
            {{ allSelected ? 'Unselect all' : 'Select all' }}
          </button>
        </div>
        <p class="wc-hint">Checked entrances get a marker. Drag markers into place on the image while editing.</p>
        <div class="wc-check-list">
          <label class="wc-check" *ngFor="let name of availableEntrances">
            <input type="checkbox" [checked]="isSelected(name)" (change)="toggle(name)" />
            <span>{{ name }}</span>
          </label>
        </div>
      </ng-container>

      <!-- ===================== Text note ===================== -->
      <ng-container *ngIf="draft.type === 'textNote'">
        <label class="wc-field">
          <span class="wc-label">Text</span>
          <textarea class="form-control wc-textarea" [(ngModel)]="draft.text" rows="4"
            placeholder="Type the text to show on the dashboard" maxlength="500"></textarea>
        </label>
        <div class="wc-text-style-row">
          <label class="wc-field wc-text-style-item">
            <span class="wc-label">Font size</span>
            <select class="form-control wc-fontsize" [(ngModel)]="draft.fontSize">
              <option *ngFor="let size of fontSizes" [ngValue]="size">{{ size }}</option>
            </select>
          </label>
          <div class="wc-field wc-text-style-item">
            <span class="wc-label">Colour</span>
            <div class="wc-color-row">
              <input type="color" class="wc-color-swatch"
                [value]="draft.textColor || (dark ? '#f8fafc' : '#0f172a')"
                (input)="onTextColorChange($event)"
                aria-label="Text colour" />
              <button type="button" class="wc-link" *ngIf="draft.textColor"
                (click)="draft.textColor = undefined">Reset</button>
            </div>
          </div>
        </div>
        <label class="wc-toggle-row">
          <input type="checkbox" [checked]="draft.bold"
            (change)="draft.bold = !draft.bold" />
          <span>Bold</span>
        </label>
      </ng-container>

      <div class="wc-actions">
        <button type="button" class="wc-btn" (click)="onCancel()">Cancel</button>
        <button type="button" class="wc-btn primary" (click)="onSave()">Save</button>
      </div>
    </tm1-card>
  </div>
</ng-container>

<app-entrance-groups *ngIf="entranceGroupsModalOpen"
  [entranceNames]="rawEntranceNames"
  [existingGroups]="entranceGroups"
  (save)="onEntranceGroupsSaved($event)"
  (cancel)="closeEntranceGroups()">
</app-entrance-groups>
